export default __webpack_public_path__ + "static/media/6-BFDC-Meeting-with-ICESTA-China(2).bfad6dda.jpg";